import React from 'react'
import './testimonials.css'

import { Swiper, SwiperSlide } from 'swiper/react';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/pagination';

// import required modules
import { Pagination } from 'swiper/modules';



const data = [
  {
    name: 'Tina Snow',
    review: 'Lorem ipsum dolor sit amet consectetur, adipisicing elit. A rerum at nam nesciunt atque dolores, facere adipisci deleniti soluta repellendus tenetur recusandae eligendi nisi eaque.'
  },
  {
    name: 'Tina Snow',
    review: 'Lorem, ipsum dolor sit amet consectetur adipisicing elit. Vero voluptatibus reiciendis est quia voluptate impedit repellendus perspiciatis sapiente ipsa nostrum.'
  },
  {
    name: 'Tina Snow',
    review: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Repellendus cum natus maiores minus veritatis animi!'
  },
  {
    name: 'Tina Snow',
    review: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Mollitia, provident!'
  }
]

const Testimonials = () => {
  return (
    <section id='testimonials'>
      <h5>Review from clients</h5>
      <h2>Testimonials</h2>

      <Swiper className="container testimonials_container"
      //install Swiper modules
      modules={[Pagination]}
      spaceBetween={40}
      slidesPerView={1}
      pagination={{clickable: true}}>
        {
          data.map(({name, review}, index) => {
            return(
              <SwiperSlide className='testimonial' key={index}>
              <h5 className='client_name'>{name}</h5>
                <small className='client_review'>{review}</small>
            </SwiperSlide>
            )
          })
        }
      </Swiper>
    </section>
  )
}

export default Testimonials